import { ChevronRight, Clipboard, GraduationCap, Target } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

type Props = {
  onChatWithTrainer: () => void;
  onViewAssessments: () => void;
};

export function ProgramTabEmptyState({ onChatWithTrainer, onViewAssessments }: Props) {
  return (
    <Card className="border-primary/20 bg-dark-card shadow-card overflow-hidden">
      <CardContent className="p-6">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-dark-slate border border-primary/15 flex items-center justify-center mb-4">
            <Target className="w-7 h-7 text-primary/70" />
          </div>
          <h4 className="text-white font-semibold text-lg mb-2">Your program is on the way</h4>
          <p className="text-sm text-gray-light max-w-sm">
            Your coach is building a personalized program for you. Chat with them and complete your
            assessments so they can tailor it to your goals.
          </p>
        </div>

        <div className="space-y-3">
          <Button
            variant="outline"
            className="w-full justify-between border-primary/30 bg-transparent text-white text-left p-4 h-auto hover:bg-dark-slate/80 hover:text-white hover:border-primary/40"
            onClick={onChatWithTrainer}
          >
            <div className="flex items-center">
              <div className="bg-primary/20 p-2 rounded-full mr-3">
                <GraduationCap className="h-5 w-5 text-primary" />
              </div>
              <div>
                <span className="font-medium block text-white">Message your trainer</span>
                <span className="text-sm text-gray-light">Share your goals and questions</span>
              </div>
            </div>
            <ChevronRight className="h-5 w-5 text-gray-400 shrink-0" />
          </Button>

          <Button
            variant="outline"
            className="w-full justify-between border-primary/30 bg-transparent text-white text-left p-4 h-auto hover:bg-dark-slate/80 hover:text-white hover:border-primary/40"
            onClick={onViewAssessments}
          >
            <div className="flex items-center">
              <div className="bg-primary/20 p-2 rounded-full mr-3">
                <Clipboard className="h-5 w-5 text-primary" />
              </div>
              <div>
                <span className="font-medium block text-white">Complete assessments</span>
                <span className="text-sm text-gray-light">Help your coach understand you better</span>
              </div>
            </div>
            <ChevronRight className="h-5 w-5 text-gray-400 shrink-0" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
